import { differenceInSeconds, startOfTomorrow } from 'date-fns';

/**
 * Returns the number of whole seconds from `now` to the next local midnight (00:00).
 *
 * - Uses local timezone rules, including DST transitions.
 * - Clamps to 0 to avoid negatives if `now` is after the computed boundary.
 *
 * @param now Optional reference time (defaults to current time). Useful for testing.
 * @returns Whole seconds until next local midnight (non-negative integer).
 */
export function secondsUntilMidnight(now: Date = new Date()): number {
  const nextMidnight = startOfTomorrow();
  const seconds = differenceInSeconds(nextMidnight, now);
  return seconds > 0 ? seconds : 0;
}
